<template>
  <div class="root">
    <p class="mode">
      <span>意向受让</span>
      <router-link :to="{ name: '意向转出受让', query: { id: 1 } }"
        >更多></router-link
      >
    </p>
    <!-- <div class="xianwenList">
      <router-link v-for="(item, index) in list0" :key="index"  :to="{name:'意向转出受让详情',query:{id:item.id}}">
        <span class="dian"></span>
        <span class="xinwen" :title="item.projectname">{{item.projectname}}</span>
        <span class="time">[{{sub(item.logintime)}}]</span>
      </router-link>
    </div> -->
    <ul class="xianwenList">
      <li v-for="(item, index) in list0" :key="index">
        <router-link :to="{ name: '意向转出受让详情', query: { id: item.id } }">
          <span :title="item.projectname">{{ item.projectname }}</span>
          <span>[{{ sub(item.logintime) }}]</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list0: [],
    }
  },
  created() {
    // 意向受让数据
    let url = 'yixiangshorang'
    // console.log("意向受让");
    // console.log(this.ajax_url(url).data);
    this.list0 = this.ajax_url(url).data
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    // 截取字符串
    // shenglue(str) {
    //   if (str.length > 30) {
    //     return str.substring(0, 30) + "...";
    //   } else {
    //     return str;
    //   }
    // },
    sub(str) {
      return str ? str.substr(0, 10) : ''
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  width: 100%;
  height: 445px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 26px 0 37px;
  width: 495px;
  height: 80px;
  border-bottom: 1px solid #dbdbdb;
}

.mode > span {
  display: block;
  width: auto;
  height: 80px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  line-height: 80px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 80px;
}

/* .xianwenList {
  padding-top: 11px;
  width: 558px;
  height: 336px;
  overflow: hidden;
}

.xianwenList>a{
   width: 500px;
   padding: 0 29px;
   padding-top: 25px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  overflow: hidden;
}
.xianwenList .dian {
   width: 12px;
height: 12px;
background: #6FA3DC;
border-radius: 50%;
}
.xianwenList .xinwen{
  padding-left: 13px;
  width: 338px;
height: 22px;
font-size: 22px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
line-height: 22px;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
}
.xianwenList .time{
  display: block;
  width: auto;
height: 22px;
font-size: 22px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
line-height: 22px;

} */
.xianwenList {
  padding: 16px 32px 0 34px;
  width: 492px;
  height: 282px;
  overflow: hidden;
  /* background-color: chocolate; */
}

.xianwenList > li {
  width: 492px;
  height: 54px;
  line-height: 27px;
  overflow: hidden;
}

.xianwenList > li > a {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  height: 23px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 23px;
  overflow: hidden;
}

.xianwenList > li > a > span:first-child {
  padding-left: 22px;
  width: 270px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: url('../../../assets/img/i1.png') no-repeat left center;
}

/* .xianwenList > a {
  position: relative;
  padding: 0 30px 0 60px;
  width: 468px;
  display: block;
  height: 84px;
  overflow: hidden;
} */
/* .xianwenList .dian {
  display: block;
  width: 12px;
  height: 12px;
  background: #6fa3dc;
  border-radius: 50%;
  position: absolute;
  top: 13px;
  left: 36px;
}
.xianwenList .xinwen {
  height: 68px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 37px;
}
.xianwenList .time {
  display: block;
  width: auto;
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  position: absolute;
  right: 30px;
  bottom: 17px;
  background-color: chocolate;
} */
</style>
